import { ReactNode } from 'react';
import styled from 'styled-components';

import {
  Flex,
  Text,
  Radio,
  RadioTile,
  RadioTileProps,
  Box,
  Divider,
  ColorsV2,
  useThemeColors,
} from '@electricjs/arc';

// forcing styles to make the RadioTile full width and matching design
const RadioTileContainer = styled(Box)`
  width: 100%;

  label {
    width: 100%;
    padding: 0 !important;

    > span {
      margin: 0 !important; // removing margin of the radio icon
    }

    > div {
      width: 100%;
      background-color: transparent !important;
      ${props => props.$noBorder && 'box-shadow: none !important;'}
    }
  }
`;

type PaymentRadioTileProps = RadioTileProps & {
  title: string;
  subtitle?: string;
  rightText?: string;
  noBorder?: boolean;
  noPadding?: boolean;
  extendedContent?: ReactNode;
};

export const PaymentRadioTile = ({
  id,
  value,
  checked,
  disabled,
  title,
  noBorder,
  noPadding,
  subtitle,
  rightText,
  extendedContent,
}: PaymentRadioTileProps) => {
  const [subtitleColor, dividerColor] = useThemeColors([
    ColorsV2.GRAY_DARK,
    ColorsV2.GRAY_LIGHT,
  ]);

  return (
    <RadioTileContainer $noBorder={noBorder}>
      <RadioTile
        id={id}
        value={value}
        checked={checked}
        disabled={disabled}
        customComponent={
          <Box width="100%" p={noPadding ? '0' : '16px'}>
            <Flex justifyContent="space-between" alignItems="center">
              <Flex columnGap="16px" alignItems="center">
                <Radio
                  id={`${id}-radio`}
                  value={value}
                  checked={checked}
                  disabled={disabled}
                />
                <Flex vertical rowGap="8px" width="100%">
                  <Text variant="label-large">{title}</Text>
                  {subtitle && (
                    <Text variant="body" color={subtitleColor}>
                      {subtitle}
                    </Text>
                  )}
                </Flex>
              </Flex>
              {rightText && <Text>{rightText}</Text>}
            </Flex>
            {extendedContent && (
              <Box ml="36px">
                <Divider space="16px" color={dividerColor} />
                {extendedContent}
              </Box>
            )}
          </Box>
        }
      />
    </RadioTileContainer>
  );
};
